import { InputProps } from '../Form/Input'
import { twMerge } from 'tailwind-merge'

/** ===== Currency input skeleton =====
 * Matches:
 * - prependElement with border-r + bg-base-50 + px-2
 * - input container border + rounded + shadow + overflow-hidden
 * - inner input padding/height feel (py-2)
 */
export const InputSkeleton = (props: InputProps) => {
  return (
    <div className='h-full w-full'>
      <div
        className={twMerge(
          'h-full w-full overflow-hidden',
          'rounded-lg ',
          props.className,
        )}>
        <div className='flex h-full w-full items-stretch'>
          <div className='flex w-full items-center px-2 py-1'>
            <div className='h-6 w-full overflow-hidden animate-pulse rounded bg-slate-200 dark:bg-slate-800' />
          </div>
        </div>
      </div>
    </div>
  )
}
